import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "nav-left" }
const _hoisted_2 = { class: "nav-right" }
const _hoisted_3 = {
  key: 0,
  class: "cart-badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Home", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("About", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "nav-button cart-button",
          to: "/cart"
        }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createTextVNode(" 🛒 Cart ", -1)),
            (_ctx.totalCartCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.totalCartCount), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (!_ctx.currentUser)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "nav-button login-button",
              to: "/login"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Login", -1)
              ]))]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "nav-button login-button",
              to: "/profile"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.firstName), 1)
              ]),
              _: 1
            }))
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}